/**
 * Converts an inspection on-site contact phone number to a string that an HTML <a> tag can use to call
 * a phone number
 *
 * @param phone the inspection on-site contact phone number
 * @returns the phone number to be used for a link as a phone number
 */
export default function getInspectionPhoneLink(phone: string): string {
  const phoneWithoutSpecialChars = phone.replaceAll(/[\s()-]/g, "");
  if (phoneWithoutSpecialChars.startsWith("+")) {
    return phoneWithoutSpecialChars;
  }
  return `+1${phoneWithoutSpecialChars}`;
}
